import styled from 'styled-components';
import { colors } from 'helpers/ColorHelper';
import CtaCard from 'components/ui/CtaCard';

const Link = styled(CtaCard)`
  flex-grow: 1;
  padding: 0;
  color: ${colors.PURE_BLUE};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: ${props => `${props.fontSize}px` || '14px'};
  text-align: right;
  float: right;
`;

export default Link;
